import { render, staticRenderFns } from "./WidgetCounter.vue?vue&type=template&id=06d6a4f2&scoped=true"
import script from "./WidgetCounter.vue?vue&type=script&lang=js"
export * from "./WidgetCounter.vue?vue&type=script&lang=js"
import style0 from "./WidgetCounter.vue?vue&type=style&index=0&id=06d6a4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d6a4f2",
  null
  
)

export default component.exports